var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"enclosure"},[_c('base-svg',{attrs:{"name":_vm.item.card_icon.path}}),_c('cms-text',{attrs:{"value":`${_vm.prefix}.list.${_vm.index}.item`,"props":{color: 'white', tag: 'div'}}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line"},[_c('div',{staticClass:"pulsatingCircle"},[_c('span',{staticClass:"firstCircle"}),_c('span',{staticClass:"secondCircle"})])])
}]

export { render, staticRenderFns }